<template>
  <div class="game-container">
    <lifebar></lifebar>

    <div class="question-container">
      <transition name="translateQuestion">
        <div v-if="data && getQuestionsCycle[0]">
          <question :params="getQuestionsCycle[0]"></question>
        </div>
      </transition>

      <transition name="translateQuestion">
        <div v-if="data && getQuestionsCycle[1]">
          <question v-if="data && getQuestionsCycle[1]" :params="getQuestionsCycle[1]"></question>
        </div>
      </transition>
    </div>

    <transition name="fadeIn">
      <popin v-if="getShowPopin && getDataPopin" :params="getDataPopin"></popin>
    </transition>
    
    <transition name="fadeIn">
      <money v-if="getAnimMoney"></money>
    </transition>
  </div>
</template>

<script>
  import Cookie from 'js-cookie';
  import Transition from '~mixins/Transition';

  import Lifebar from './Lifebar';
  import Question from './Question';
  import Popin from '../Popin';
  import Money from './Money';

  export default {
    name: 'game',
    components: {
      Lifebar,
      Question,
      Popin,
      Money,
    },
    mixins: [Transition],
    data() {
      let actual = parseInt(this.$store.getters.getActualQuestion, 10);

      if (!actual) {
        if (Cookie.get('question')) {
          actual = parseInt(JSON.parse(Cookie.get('question')).actual, 10);
        } else {
          actual = 1;
        }
      }

      if (this.$store.getters.getQuestionsData && !Cookie.get('question')) {
        this.$store.commit('setQuestionCycle', {
          index: 0,
          data: this.$store.getters.getQuestionsData['1'],
        });
      } else if (Cookie.get('question')) {
         this.$store.commit('setQuestionCycle', {
          index: 0,
          data: JSON.parse(Cookie.get('question')).data,
        });        
      }

      return {
        actual: actual,
        data: this.$store.getters.getQuestionsData,
      };
    },
    watch: {
      getQuestionsData(n) {
        this.data = n;

        if (!Cookie.get('question')) {
          this.$store.commit('setQuestionCycle', {
            index: 0,
            data: this.$store.getters.getQuestionsData['1'],
          });    
        }
      },
    },
    computed: {
      getQuestionsData() {
        return this.$store.getters.getQuestionsData;
      },
      getQuestionsCycle() {
        return this.$store.getters.getQuestionsCycle;
      },
      getShowPopin() {
        return this.$store.getters.getShowPopin;
      },
      getDataPopin() {
        return this.$store.getters.getDataPopin;
      },
      getAnimMoney() {
        return this.$store.getters.getAnimMoney;
      },
    },
  };
</script>


<style lang="scss">
  .game-container,
  .question-container {
    width: 100%;
    height: 100%;
    overflow: hidden;

    @include mobile {
      height: auto;
    }
  }

  .question-container {
    position: relative;
    opacity: 0;
    animation: appearBottom .4s .1s ease-in-out forwards;

    @include mobile {
      height: 550px;
    }

    > div {
      // padding-top: 170px;
      position: absolute;
      top: calc(50% + 50px);
      left: 50%;
      transform: translate(-50%, -50%);

      @include mobile {
        width: 100%;
      }
    }
  }

  .translateQuestion-enter-active {
    transition: transform 1s .2s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 1s .2s ease;
  }

  .translateQuestion-leave-active {
    transition: transform 1s .2s ease, opacity 1s .2s ease;
  }

  .translateQuestion-enter,
  .translateQuestion-leave-to {
    opacity: 0;
  }

  .question-container > div.translateQuestion-enter {
    transform: translate(100%, -50%);
  }

  .question-container > div.translateQuestion-leave-to {
    transform: translate(-200%, -50%);
  }
</style>



// WEBPACK FOOTER //
// Game.vue?819a064e